import { DownOutlined } from "@ant-design/icons";
import { useQueryClient } from "@tanstack/react-query";
import KEYS from "api/queries/keys";
import { Button, Dropdown, Form, Space } from "components/styleguide";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import ImportDrawer from "./ImportDrawer";

export default function TimeslotImport({ forumId }: { forumId: number }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const [isTimeslotDrawerOpen, setIsTimeslotDrawerOpen] = useState(false);

  const closeAllDrawers = () => {
    setIsTimeslotDrawerOpen(false);
    queryClient.removeQueries([KEYS.GET_TIMESLOT_IMPORT]);
  };

  const menuProps = {
    items: [
      {
        label: t("Import Timeslots"),
        key: "timeslots",
        onClick: () => setIsTimeslotDrawerOpen(true),
      },
    ],
  };

  return (
    <>
      <Dropdown menu={menuProps}>
        <Button>
          <Space>
            {t("Import")}
            <DownOutlined style={{ fontSize: "12px" }} />
          </Space>
        </Button>
      </Dropdown>
      <ImportDrawer
        forumId={forumId}
        title={t("Import Timeslots")}
        visible={isTimeslotDrawerOpen}
        onClose={() => {
          setIsTimeslotDrawerOpen(false);
          queryClient.removeQueries([KEYS.GET_TIMESLOT_IMPORT]);
        }}
        onImported={() => {
          closeAllDrawers();
          queryClient.resetQueries([KEYS.GET_TIMESLOTS]);
        }}
        form={form}
      />
    </>
  );
}
